module.exports = __webpack_public_path__ + "img/level-company.a9029909.svg";